// Axios
import axiosInstance from '../axios/axiosInstance';

const getArvoreLinhas = async () => {
  const res = await axiosInstance.get(`arvore/`);
  return res.data;
};

const getArvoreEquips = async (tag) => {
  try {
    const res = await axiosInstance.get(`equipamentoAr/?tag=${tag}`);
    return res.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};

const getSearchMaquinario = async (tag) => {
  try {
    const res = await axiosInstance.get(`maquinario/${tag}`);
    return res.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};

const arvoreService = {
  getArvoreLinhas,
  getArvoreEquips,
  getSearchMaquinario,
};

export default arvoreService;
